import { Avatar, Empty, Input, Modal, Tooltip } from "antd";
import "./messages.scss";
import React, { useContext, useEffect, useMemo, useState } from "react";
import httpclient from "../../../../service/httpclient";
import moment from "moment";
import { NavLink } from "react-router-dom";
import { MessageContext } from "../../../../App";
import { DeleteOutlined, UserOutlined } from "@ant-design/icons";
import { isSet } from "lodash/lang";

function Messages() {
  const [replyModalVisible, setReplyModalVisible] = useState(false);
  const [replyContent, setReplyContent] = useState('');
  const [currentReplyUserId, setCurrentReplyUserId] = useState(null);
  const [currentReplyUserName, setCurrentReplyUserName] = useState('');

  const handleReplyClick = (userId, userName) => {
    setCurrentReplyUserId(userId);
    setCurrentReplyUserName(userName || '用户');
    setReplyContent('');
    setReplyModalVisible(true);
  };

  const handleReplySubmit = () => {
    if (!replyContent.trim()) {
      Modal.warning({
        title: '提示',
        content: '请输入回复内容',
      });
      return;
    }
    

    httpclient.replyMessage({
      receiver_id: 17,
      messageData: replyContent
    }).then((response) => {
      Modal.success({
        title: '发送成功',
        content: '您的回复已发送',
        onOk: () => {
          setReplyModalVisible(false);
          setReplyContent('');
        }
      });
    }).catch((error) => {
      Modal.error({
        title: '发送失败',
        content: error.errMsg || error.message || '发送回复时出现错误'
      });
    });
  };

  function sortByTime(a, b) {
    let timea = moment(a.created_at).format("YYYY-MM-DD HH:mm:ss");
    let timeb = moment(b.created_at).format("YYYY-MM-DD HH:mm:ss");
    if (moment(timea).isBefore(timeb)) {
      return 1;
    } else return -1;
  }
  const [messages, setMessages] = useState(null);
  const { unreadMessageCnt, delCnt } = useContext(MessageContext);
  useEffect(() => {
    httpclient.getMessages().then((data) => {
      if (data.messages.length) {
        setMessages(data.messages);
      }
      delCnt(data.del_cnt);
    });
    // setInterval(() => {
    //   httpclient.getMessages().then((data) => {
    //     setMessages(data);
    //   })
    // },10000);
  }, [localStorage.token]);
  const messagelist = useMemo(() => {
    if (messages) {
      return messages.sort(sortByTime).map((content) => {
        return (
          <div
            className="message-item"
            onMouseOver={() => {
              const deleteDom = document.getElementsByClassName(
                `message-delete ${content.id}`
              )[0];
              if (deleteDom) {
                deleteDom.style.display = "block";
              }
            }}
            onMouseOut={() => {
              if (document.body.offsetWidth >= 600) {
                const deleteDom = document.getElementsByClassName(
                  `message-delete ${content.id}`
                )[0];
                if (deleteDom) {
                  deleteDom.style.display = "none";
                }
              }
            }}
          >
            <NavLink to={content.link || "/"} style={{ display: "flex", flex: 1 }}>
              {content.user_avatar ? (
                <Avatar
                  className="message-user-avatar"
                  size={{
                    xs: 32,
                    sm: 40,
                    md: 48,
                    lg: 48,
                    xl: 48,
                    xxl: 48,
                  }}
                  src={content.user_avatar}
                />
              ) : (
                <Avatar
                  className="message-user-avatar"
                  size={{
                    xs: 32,
                    sm: 40,
                    md: 48,
                    lg: 48,
                    xl: 48,
                    xxl: 48,
                  }}
                  icon={<UserOutlined />}
                />
              )}
              <div className="message-body">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="message-user-name">
                    {content.user_name || content.mobile}
                  </div>
                  <div className="message-desc">{content.desc}</div>
                </div>
                <div className="message-content">
                  {content.type === "like" && (
                    <span style={{ color: "darkgery", fontSize: "12px" }}>
                      我的评论：
                    </span>
                  )}
                  {content.content}
                </div>
                <div className="message-date-wrapper">
                  <div className="message-date">
                    {moment(content.created_at).format("YYYY-MM-DD HH:mm")}
                  </div>
                  <div
                    className={`message-delete ${content.id}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      Modal.confirm({
                        title: "是否确认删除该通知？",
                        okType: "primary",
                        okText: "确定",
                        cancelText: "取消",
                        onOk: async function () {
                          httpclient.deleteMessage(content.id).then(() => {
                            window.location.reload();
                          });
                        },
                      });
                    }}
                  >
                    <Tooltip title="删除该通知">
                      <DeleteOutlined />
                    </Tooltip>
                  </div>
                </div>
              </div>
            </NavLink>
            {content.user_id === 17 && (
              <div
                className="message-reply-button"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleReplyClick(content.user_id, content.user_name);
                }}
              >
                回复
              </div>
            )}
          </div>
        );
      });
    }
  }, [messages]);
  return (
    <div className="message">
      {messages ? (
        <div>{messagelist}</div>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无消息" />
      )}
      <Modal
        title={`回复给 ${currentReplyUserName}`}
        visible={replyModalVisible}
        onOk={handleReplySubmit}
        onCancel={() => {
          setReplyModalVisible(false);
          setReplyContent('');
        }}
        okText="发送"
        cancelText="取消"
        okButtonProps={{ disabled: !replyContent.trim() }}
      >
        <Input.TextArea
          value={replyContent}
          onChange={(e) => setReplyContent(e.target.value)}
          placeholder="请输入回复内容..."
          rows={6}
          maxLength={500}
          showCount
        />
      </Modal>
    </div>
  );
}

export default Messages;
